import axios from 'axios';
import {
  V1_EXPORT_SUPPLIER,
  V1_SUPPLIER_BY_ID,
  V1_SUPPLIER,
} from './constants';

function reject(error) {
  let eobj;
  if (error.response) {
    const { data } = error.response;
    if (data.code && data.code === '0010-0001') {
      eobj = new Error(`Supplier does not found or already removed`);
    } else if (data.errors) {
      eobj = new Error(data.errors);
    } else if (data.message) {
      eobj = new Error(data.message);
    } else {
      eobj = new Error(error.message);
    }
  } else {
    eobj = new Error(error.message);
  }
  return Promise.reject(eobj);
}

export function getSuppliers(params) {
  return axios
    .get(V1_SUPPLIER, { params, withCredentials: true })
    .catch(reject);
}

export function getExportSupplier(email, keyword) {
  const params = { email, keyword };
  return axios
    .get(V1_EXPORT_SUPPLIER, { params, withCredentials: true })
    .catch(reject);
}

export function deleteSupplier(id, name, params) {
  return axios
    .delete(V1_SUPPLIER_BY_ID(id), { params, withCredentials: true })
    .catch(error => reject(error, name));
}

export function putSupplier(id, data, params) {
  return axios
    .put(V1_SUPPLIER_BY_ID(id), data, { params, withCredentials: true })
    .catch(error => reject(error, data.name));
}

export function postSuppliers(data, params) {
  return axios
    .post(V1_SUPPLIER, data, { params, withCredentials: true })
    .catch(reject);
}
